import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppStateService } from './Core/Services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  private deferredSubscription: Subscription;

  isQuestionLoading: boolean = true;
  constructor(
    private appStateService: AppStateService) { }


  ngOnInit() {
    this.appStateService.initSessionTracker();
    this.appStateService.loadDeferredFile();
  }

  ngOnDestroy(): void {
    if (this.deferredSubscription) {      
      this.deferredSubscription.unsubscribe();
    }
  }
}
